import { SearchOutlined } from '@teko/ds-icon';
import { BottomSheet, Input, styled } from '@teko/ds-mobile';
import { FilterOption } from '@teko/types/ecommerce';
import { t } from 'i18n';
import { SortOptionInterface } from 'modules/search-page/shared';
import React, { useState } from 'react';
import { HamperModalComponent } from './HamperModalComponent';

type HamperModalProps = {
  collectionSlug: string;
  visible: boolean;
  hamperItemKey: string;
  onClose: () => void;
};

const BOTTOM_SHEET_HEADER_HEIGHT = '57px';

export const HamperModalMobile: React.FC<HamperModalProps> = (props) => {
  const { collectionSlug, hamperItemKey, visible, onClose } = props;
  const [keyword, setKeyword] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const [priceFilterValue, setPriceFilterValue] = useState<{
    gte: number;
    lte: number;
  }>();

  const [activeOptions, setActiveOptions] = useState<FilterOption[]>([]);
  const [activeSortOption, setActiveSortOption] = useState<
    SortOptionInterface | undefined
  >();

  const onClickSearch = (keyword: string) => {
    setKeyword(keyword);
    setCurrentPage(1);
  };

  const clearFilter = () => {
    setPriceFilterValue(undefined);
    setActiveOptions([]);
    setActiveSortOption(undefined);
  };

  return (
    <StyledBottomSheet
      show={visible}
      closeBottomSheet={() => {
        onClose?.();
        clearFilter();
      }}
      forceRender
      closeIconPosition="right"
      contentHeight={`calc(100% - ${BOTTOM_SHEET_HEADER_HEIGHT})`}
      showBottomSheetHeader
      filterNode={
        <Input
          placeholder={t('Tìm kiếm')}
          width="80%"
          marginLeft="s20"
          onKeyUp={(e) => {
            const keyword = (e.target as HTMLInputElement).value;
            if (e.keyCode === 13) {
              onClickSearch(keyword);
            }
          }}
          prefix={<SearchOutlined size={20} />}
        />
      }
    >
      <HamperModalComponent
        collectionSlug={collectionSlug}
        hamperItemKey={hamperItemKey}
        keyword={keyword}
        currentPage={currentPage}
        onPageChange={setCurrentPage}
        activeOptions={activeOptions}
        activeSortOption={activeSortOption}
        priceFilterValue={priceFilterValue}
        setActiveSortOption={setActiveSortOption}
        setActiveOptions={setActiveOptions}
        setPriceFilterValue={setPriceFilterValue}
      />
    </StyledBottomSheet>
  );
};

const StyledBottomSheet = styled(BottomSheet)`
  height: 100%;
  width: 100%;
  overflow-y: visible;
  -webkit-overflow-scrolling: auto;
  .bottom-sheet-header {
    padding: 8px;
    height: ${BOTTOM_SHEET_HEADER_HEIGHT};
  }
`;
